// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1BpjU","actions":"GroupTable_actions__33lrx","deleteModalFooter":"GroupTable_deleteModalFooter__1AGtQ"};